module.exports = __webpack_public_path__ + "media/images/new-ui-images/dropdown-dot-d30d8b32d2b38839e874cf77e7faa805.svg";